// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontSize": "14px",
	"blue": "#0d45a4",
	"grey": "#737c84",
	"greyLight": "#ccc",
	"black": "#000",
	"green": "#76bf76",
	"yellow": "#f2a449",
	"red": "#f75769",
	"primary": "var(--primary)",
	"info": "hsl(207,61%,53%)",
	"white": "#fff",
	"orange": "#f56021",
	"secondary": "var(--primary-10)",
	"greyLighter": "hsl(0,0%,92%)"
};
export default ___CSS_LOADER_EXPORT___;
